import { State } from '../reducers/rootReducer'
import DigitalGiveawayLinkUrl from '../../entities/DigitalGiveawayLinkUrl'

const digitalGiveawayLinkSelector = (state: State): DigitalGiveawayLinkUrl => state.digitalGiveawayLink

export default digitalGiveawayLinkSelector
